import { IBaseIconProps } from "./IBaseIconProps";

export const SendIcon = ({
  color = "#000",
  backgroundColor,
}: IBaseIconProps) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40 8L6 22L20 28M40 8L26 42L20 28M40 8L20 28"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
